<template>
  <div class="forward-center"></div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { addHashQuery, setCookie } from '@/lib/util.ts';
@Component({
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    const api = window.isWechat
      ? window.apis.getWechatForward
      : window.apis.getWapForward;
    const goDefault = () => {
      next({ path: '/', query: to.query });
    };
    api(to.query)
      .then((res: any) => {
        const { data } = res;
        if (!window.isWechat && !res.errcode && data) {
          // 2019年08月21日 与服务端约定，/wap/forward 返回字段除 redirect 外
          // 其余字段都须存入Cookie
          Object.keys(data)
            .filter(key => key !== 'redirect')
            .forEach(key => {
              setCookie(key, data[key]);
            });
        }

        if (data && data.redirect) {
          const redirect = data.redirect;
          const reg = /^http/;
          if (reg.test(redirect)) {
            next(() => {
              window.location.href = addHashQuery(data.redirect, to.query);
            });
          } else {
            next({
              path: redirect,
              replace: true,
              query: to.query,
            });
          }
        } else {
          goDefault();
        }
      })
      .catch(() => {
        goDefault();
      });
  },
})
export default class ForwardCenter extends Vue {}
</script>
